import { describeError } from '../api/client';

interface Props {
  error: unknown;
  onRetry?: () => void;
}

export function ErrorBanner({ error, onRetry }: Props) {
  if (!error) return null;
  const { message, errorId } = describeError(error);

  return (
    <div className="error-banner" role="alert">
      <div>{message}</div>
      {errorId && <div className="error-banner__id">error_id: {errorId}</div>}
      {onRetry && (
        <div style={{ marginTop: 8 }}>
          <button type="button" onClick={onRetry}>
            Повторить
          </button>
        </div>
      )}
    </div>
  );
}
